import { useLang } from "../../i18n/LanguageContext";

export default function ServicePanels({ active }) {
  const { t } = useLang();
  const panel = t.services.panels[active] || t.services.panels[0];

  return (
    <div className="space-y-10">
      {/* Main grid */}
      <div className="grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 space-y-6">
          <h3 className="text-2xl sm:text-3xl font-black text-white flex items-center gap-3">
            <span className="w-2 h-8 bg-[#F28C18] block flex-shrink-0" />
            {panel.title}
          </h3>
          <p className="text-zinc-400 text-sm leading-relaxed">{panel.desc}</p>
          <div className="grid sm:grid-cols-2 gap-3">
            {panel.features.map((f) => (
              <div key={f} className="p-3 bg-white/5 rounded border border-white/5 flex items-center gap-2 text-xs font-medium text-zinc-300">
                <i className="fas fa-check text-[#F28C18] flex-shrink-0" /> {f}
              </div>
            ))}
          </div>
          {/* Brands + Standards row */}
          <div className="grid sm:grid-cols-2 gap-6 pt-2">
            <div>
              <div className="text-[10px] font-black text-zinc-500 uppercase tracking-widest mb-2">Approved Brands</div>
              <div className="flex flex-wrap gap-2">
                {panel.brands.map(b => (
                  <span key={b} className="px-3 py-1 bg-white/5 border border-white/5 rounded text-[10px] font-black text-zinc-400 uppercase tracking-wider">{b}</span>
                ))}
              </div>
            </div>
            <div>
              <div className="text-[10px] font-black text-zinc-500 uppercase tracking-widest mb-2">Standards</div>
              <div className="flex flex-wrap gap-2">
                {panel.standards.map(s => (
                  <span key={s} className="px-3 py-1 bg-[#F28C18]/10 border border-[#F28C18]/20 rounded text-[10px] font-black text-[#F28C18] uppercase tracking-wider">{s}</span>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="w-full h-80 rounded-lg border border-white/10 relative overflow-hidden group shadow-2xl shadow-black bg-zinc-900">
            <img src={panel.img} alt={panel.title}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 brightness-75 group-hover:brightness-100" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent flex flex-col justify-end p-6 text-left">
              <div className="text-xs font-black tracking-widest uppercase text-[#F28C18]">{panel.imgLabel}</div>
              <div className="text-[11px] text-zinc-300 mt-1">{panel.imgSub}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
